import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_row, {
    "no-gutters": "",
    class: "d-flex justify-center",
    style: {"height":"80vh","width":"100vw"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn_back, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.routeBack())),
            class: "ma-2"
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "6",
        class: "align-self-center default_card"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "pa-3" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_file_input, {
                    modelValue: _ctx.folder,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.folder) = $event)),
                    "show-size": "",
                    outlined: "",
                    dense: "",
                    "prepend-icon": "$fa-folder",
                    label: "Select folder",
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setFolderData())),
                    webkitdirectory: "",
                    multiple: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "d-flex"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "6",
                class: "pa-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_file_input, {
                    modelValue: _ctx.files.table,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.files.table) = $event)),
                    "show-size": "",
                    outlined: "",
                    dense: "",
                    label: "File Form",
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setTableFile()))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "pa-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_file_input, {
                    modelValue: _ctx.files.rules,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.files.rules) = $event)),
                    "show-size": "",
                    outlined: "",
                    dense: "",
                    label: "File Rules",
                    onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setRulesFile()))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "pa-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_file_input, {
                    modelValue: _ctx.files.values,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.files.values) = $event)),
                    "show-size": "",
                    outlined: "",
                    dense: "",
                    label: "File Values",
                    onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setValuesFile()))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "pa-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_file_input, {
                    modelValue: _ctx.files.cerfa,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.files.cerfa) = $event)),
                    "show-size": "",
                    outlined: "",
                    dense: "",
                    label: "File Cerfa JSON",
                    onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setCerfaFile()))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "pa-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_file_input, {
                    modelValue: _ctx.files.image,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.files.image) = $event)),
                    "show-size": "",
                    outlined: "",
                    dense: "",
                    label: "File Cerfa Image",
                    onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setImageFile()))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                class: "d-flex justify-end pa-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "ma-1",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.clear())),
                    onKeydown: _cache[14] || (_cache[14] = _withKeys(($event: any) => (_ctx.clear()), ["enter"])),
                    rounded: "",
                    elevation: "0"
                  }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode(" Effacer la sélection ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    class: "ma-1",
                    rounded: "",
                    elevation: "0",
                    disabled: !_ctx.isFormValid,
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.valid()))
                  }, {
                    default: _withCtx(() => _cache[17] || (_cache[17] = [
                      _createTextVNode(" Valider ")
                    ])),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}